import React, { Component } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import BootstrapTable, {
  SelectRowProps,
  SortOrder,
  TableChangeState,
  TableChangeType,
} from "react-bootstrap-table-next";
import { Badge, Button, Col, InputGroup, Modal, OverlayTrigger, Spinner, Table, Tooltip } from "react-bootstrap";
import {
  getEvidenceAssessments,
  getEvidenceInDataPeriod,
  hideSearchForYourAssessmentModal,
  hideUploadStudentDataModal,
  openAddAssessmentModal,
  // openUploadStudentDataModal,
  openFileUploadErrorModal,
  updateCsvFileRawData,
  uploadUndefinedAssessmentData,
} from "../../../../../store/onboarding/actions";
import LoadingIndicator from "../../LoadingIndicator";
import {
  DataPeriod,
  EvidenceAssessment,
  EvidencePeriodData,
  Measurement,
  Student,
} from "../../../../../store/onboarding/types";
import Form from "react-bootstrap/Form";
import { toastr } from "react-redux-toastr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faEye, faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { TimePeriod } from "../../../../../store/groups/types";
import { addStudentMapToLocalStore } from "../../../../../utils/StudentMapUtils";
import { GoalTypes } from "../../../../../store/onboarding/cases/types";
import { UserAssignmentRole } from "../../../../../store/auth/types";
import PreviewDataCell from "./PreviewDataCell";
import { dibels_columns } from "../../../../../utils/files";

const columns = [
  {
    dataField: "id",
    text: "Assessment Id",
    hidden: true,
  },
  {
    dataField: "name",
    text: "Assessment Name",
    sort: true,
    headerStyle: { whiteSpace: "nowrap" },
  },
  {
    dataField: "is_system_assessment",
    text: "Type",
    sort: true,
    headerStyle: { whiteSpace: "nowrap" },
    formatter: (_: any, row: any) => {
      return row.is_system_assessment ? (
        <Badge variant="primary">System</Badge>
      ) : (
        <Badge variant="secondary">Custom</Badge>
      );
    },
  },
  {
    dataField: "use_grade_specific_color_criteria",
    text: "Grade Specific Color Criteria",
    sort: true,
    headerStyle: { whiteSpace: "nowrap" },
    formatter: (_: any, row: any) => {
      return <div className="text-center">
        <Form.Check
          type="checkbox"
          checked={row.use_grade_specific_color_criteria}
          disabled
          custom
        />
      </div>
    },
  },
  {
    dataField: "with_reading_algorithm",
    text: "Reading Algorithm",
    sort: true,
    headerStyle: { whiteSpace: "nowrap" },
    formatter: (_: any, row: any) => {
      return <div className="text-center">
        <Form.Check
          type="checkbox"
          checked={row.with_reading_algorithm}
          disabled
          custom
        />
      </div>
    },
  },
  {
    dataField: "dataColumns",
    text: "Column Name(s)",
    sort: true,
  },
  {
    dataField: "createdBy",
    text: "Created By",
    sort: true,
    headerStyle: { whiteSpace: "nowrap", width: "15%" },
  },
  {
    dataField: "actions",
    text: "Actions",
    headerStyle: { textAlign: "center" as const },
    style: { textAlign: "center" as const },
    formatter: (_: any, row: any) => row.actionsElement,
  },
];

const defaultSorted: [{ dataField: string; order: SortOrder }] = [
  {
    dataField: "name",
    order: "asc",
  },
];

type PropsFromState = {
  columnsNames: Array<string>;
  showModal: boolean;
  evidenceAssessments: Array<EvidenceAssessment>;
  currentRole: UserAssignmentRole;
  evidencePeriodData?: EvidencePeriodData;
  currentDataPeriod?: DataPeriod;
  rawData: any;
  studentIdColumn?: string;
  isLoading: {
    uploadUndefinedAssessmentData: boolean;
    getEvidenceAssessments: boolean;
  };
  errors: {
    uploadUndefinedAssessmentData?: string | Array<any>;
    getEvidenceAssessments?: string;
  };
  enterDataManuallyType?: GoalTypes;
};

type DispatchProps = {
  getEvidenceInDataPeriod: (dataPeriodId?: number) => any;
  getEvidenceAssessments: () => any;
  hideSearchForYourAssessmentModal: () => any;
  hideUploadStudentDataModal: () => any;
  uploadUndefinedAssessmentData: (
    assessmentId: number,
    column_name_mappings: any,
    gradeColumn: string,
    teacherColumn: string,
    raceColumn: string,
    genderColumn: string,
    ellColumn: string,
    sldColumn: string,
    specialEducationColumn: string,
    freeOrReducedLunchColumn: string,
    timePeriod: string,
    assessmentUniqueIdColumn: string,
    customUniqueIdColumn: string,
    isDistrictAdmin: boolean,
    uploadUndefinedAssessmentData?: number,
    year?: number
  ) => any;
  updateRawDataOfCsvFile: (rawData: any) => any;
  //openUploadStudentDataModal: (fromSearchYourAssessment: boolean) => void;
  openFileUploadErrorModal: (message: any) => void;
  openAddAssessmentModal: (isNewProgressMonitoring?: boolean, assessment?: EvidenceAssessment, mode?: 'create' | 'edit' | 'view', fromPage?: string) => any;
};

type Props = PropsFromState & DispatchProps;

type State = {
  assessmentsFilter: string;
  selectedAssessment?: EvidenceAssessment;
  selectedAssessmentId?: number;
  evidenceAssessments: Array<EvidenceAssessment>;
  column_name_mappings: any;
  isDistrictAdmin: boolean;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
  gradeColumn?: string;
  teacherColumn?: string;
  raceColumn?: string;
  genderColumn?: string;
  ellColumn?: string;
  sldColumn?: string;
  specialEducationColumn?: string;
  freeOrReducedLunchColumn?: string;
  timePeriod?: string;
  year: string;
  isInvalid: boolean;
  numPreviewRows: number;
};

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
class SearchForYourAssessmentModal extends Component<Props, State> {
  state: Readonly<State> = {
    evidenceAssessments: [],
    assessmentsFilter: "",
    selectedAssessment: undefined,
    selectedAssessmentId: undefined,
    gradeColumn: "",
    teacherColumn: "",
    raceColumn: "",
    genderColumn: "",
    ellColumn: "",
    sldColumn: "",
    specialEducationColumn: "",
    freeOrReducedLunchColumn: "",
    column_name_mappings: {},
    isDistrictAdmin: this.props.currentRole == 'district_owner' ? true : false,
    year: "2019",
    isInvalid: false,
    sortField: undefined,
    sortOrder: undefined,
    numPreviewRows: 3,
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (
      prevProps.isLoading.getEvidenceAssessments &&
      !this.props.isLoading.getEvidenceAssessments &&
      !this.props.errors.getEvidenceAssessments
    ) {
      this.setState({ evidenceAssessments: this.props.evidenceAssessments });
    }

    if (
      prevProps.isLoading.uploadUndefinedAssessmentData &&
      !this.props.isLoading.uploadUndefinedAssessmentData
    ) {
      if (!this.props.errors.uploadUndefinedAssessmentData) {
        const { rawData, studentIdColumn, currentDataPeriod } = this.props;
        const assessment = this.state.selectedAssessment;
        if (assessment && studentIdColumn) {
          const studentMap = new Map<string, Student>(
            rawData.map((row: any) => [
              row[studentIdColumn],
              {
                first_name:
                  row[
                  this.state.column_name_mappings[
                  assessment.first_name_column
                  ]
                  ],
                last_name:
                  row[
                  this.state.column_name_mappings[assessment.last_name_column]
                  ],
              },
            ])
          );
          addStudentMapToLocalStore(studentMap);
        }
        if (!this.state.isInvalid) {
          this.props.hideSearchForYourAssessmentModal();
          this.props.hideUploadStudentDataModal();
          this.setState({ selectedAssessment: undefined, selectedAssessmentId: undefined });
          // if (this.props.currentRole !== UserAssignmentRole.DISTRICT_OWNER) {
          //   this.props.getEvidenceInDataPeriod(
          //     currentDataPeriod ? currentDataPeriod.id : undefined
          //   );
          // }
        }
      } else {
        if (JSON.stringify(this.props.errors.uploadUndefinedAssessmentData)?.includes('tab_name')) {
          this.props.openFileUploadErrorModal(this.props.errors.uploadUndefinedAssessmentData)
        } else {
          const errorMsg = Array.isArray(this.props.errors.uploadUndefinedAssessmentData)
            ? this.props.errors.uploadUndefinedAssessmentData.join(", ")
            : this.props.errors.uploadUndefinedAssessmentData;
          toastr.error("Failed", errorMsg || "An error occurred");
        }
      }
    }

    //MODAL OVERLAY CLASS HACKS

    // if (!prevProps.showModal && this.props.showModal) {
    //   document.body.style.overflow = "hidden";
    //   document.body.classList.add("modal-open");
    // }
  }

  // Helper method to find matching column using dibels_columns variations and partial matching
  findMatchingColumn = (measurementColumnName: string, availableColumns: string[]): string | undefined => {
    // First, try exact match
    const exactMatch = availableColumns.find((col) => col === measurementColumnName);
    if (exactMatch) return exactMatch;

    // Then try case-insensitive exact match
    const caseInsensitiveMatch = availableColumns.find(
      (col) => col.toLowerCase() === measurementColumnName.toLowerCase()
    );
    if (caseInsensitiveMatch) return caseInsensitiveMatch;

    // Extract potential DIBELS codes from the measurement name
    // This handles cases like "Benchmark_Status_LNF_1st_Beginning" containing "LNF"
    const extractDibelsCode = (name: string): string[] => {
      const codes: string[] = [];
      
      // Check each DIBELS standard name and variation
      for (const [standardName, variations] of Object.entries(dibels_columns)) {
        const allNamesToCheck = [standardName, ...variations];
        
        for (const dibelsName of allNamesToCheck) {
          // Create a regex to find the DIBELS code as a separate word/token in the measurement name
          // This matches: "LNF" in "Benchmark_Status_LNF_1st_Beginning"
          const codeRegex = new RegExp(
            `(^|[\\s_\\-().:/])${dibelsName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([\\s_\\-().:/]|$)`,
            'i'
          );
          
          if (codeRegex.test(name)) {
            codes.push(standardName);
            // Also include all variations for this standard
            codes.push(...variations);
            break; // Move to next standard name once we found a match
          }
        }
      }
      
      return codes;
    };

    // Check if this measurement has known variations in dibels_columns
    for (const [standardName, variations] of Object.entries(dibels_columns)) {
      // Check if the measurement column name matches the standard name or any variation
      const matchesStandardName = 
        standardName.toLowerCase() === measurementColumnName.toLowerCase() ||
        variations.some((v) => v.toLowerCase() === measurementColumnName.toLowerCase());

      if (matchesStandardName) {
        // Try to find any of the variations in the available columns
        for (const variation of variations) {
          const matchedColumn = availableColumns.find(
            (col) => col.toLowerCase() === variation.toLowerCase()
          );
          if (matchedColumn) return matchedColumn;
        }
        
        // Also check if standard name exists in available columns
        const standardMatch = availableColumns.find(
          (col) => col.toLowerCase() === standardName.toLowerCase()
        );
        if (standardMatch) return standardMatch;
      }
    }

    // NEW: Extract DIBELS codes from complex measurement names and try to match
    // Example: "Benchmark_Status_LNF_1st_Beginning" extracts "LNF" and matches "LNF(LNF)"
    const extractedCodes = extractDibelsCode(measurementColumnName);
    if (extractedCodes.length > 0) {
      for (const code of extractedCodes) {
        // Try to find this code in available columns using flexible matching
        const codeMatch = availableColumns.find((col) => {
          const colLower = col.toLowerCase();
          const codeLower = code.toLowerCase();
          
          // Try multiple matching strategies for the extracted code:
          
          // 1. Exact match (case-insensitive)
          if (colLower === codeLower) return true;
          
          // 2. Column starts with the code followed by common separators
          // Matches: "LNF(LNF)", "LNF Score", "LNF-Test", "LNF_Result"
          if (colLower.startsWith(codeLower + '(') ||
              colLower.startsWith(codeLower + ' ') ||
              colLower.startsWith(codeLower + '-') ||
              colLower.startsWith(codeLower + '_')) {
            return true;
          }
          
          // 3. Code appears as a complete word/token in the column
          // Matches: "Score LNF", "Test_LNF_Result", "LNF (Spring)"
          const codeInColumnRegex = new RegExp(
            `(^|[\\s_\\-().:/])${codeLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([\\s_\\-().:/]|$)`,
            'i'
          );
          
          return codeInColumnRegex.test(colLower);
        });
        
        if (codeMatch) return codeMatch;
      }
    }

    // Partial/word matching - match if measurement name appears as a word in the column
    // This handles cases like:
    // - "LNF" matching "LNF Score", "Score LNF", "LNF (Spring)"
    // - "Reading" matching "Reading Score", "Early Reading"
    const measurementLower = measurementColumnName.toLowerCase();
    
    // Create a regex to match the measurement name as a whole word
    // Handles various separators: spaces, hyphens, underscores, parentheses, etc.
    const wordBoundaryRegex = new RegExp(
      `(^|[\\s_\\-().:/])${measurementLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}([\\s_\\-().:/]|$)`,
      'i'
    );
    
    const partialMatch = availableColumns.find((col) => 
      wordBoundaryRegex.test(col)
    );
    if (partialMatch) return partialMatch;

    // Try to match if the column contains all significant words from the measurement name
    // Split by common separators and filter out very short words
    const measurementWords = measurementLower
      .split(/[\s_\-().:/]+/)
      .filter(word => word.length > 1); // Ignore single character words
    
    if (measurementWords.length > 0) {
      const multiWordMatch = availableColumns.find((col) => {
        const colLower = col.toLowerCase();
        // Check if all significant words from measurement appear in column
        return measurementWords.every(word => colLower.includes(word));
      });
      
      if (multiWordMatch) return multiWordMatch;
    }

    // Reverse matching: check if column name appears in measurement name
    // This helps with cases where measurement is more specific than column
    // e.g., measurement "ORF-WordsCorrect" matches column "ORF"
    const reverseMatch = availableColumns.find((col) => {
      if (col.length < 3) return false; // Avoid matching very short columns
      const colLower = col.toLowerCase();
      return measurementLower.includes(colLower);
    });
    
    if (reverseMatch) return reverseMatch;

    return undefined;
  };

  handleAssessmentSelect = (selectedAssessmentId: number, isSelect: boolean) => {
    if (isSelect) {
      this.setState((prevState: State, prevProps: Props) => {
        const selectedAssessment = prevProps.evidenceAssessments.find(
          (x) => x.id === selectedAssessmentId
        );
        if (selectedAssessment) {
          // Get autoselected columns
          const { columnsNames } = this.props;
          
          // Student ID
          const commonStudentIdRegex =
            /^(?:student[\s_-]*)?(?:primary[\s_-]*)?id#?$/i;
          const commonStudentIdColumn = columnsNames.find((columnName) =>
            commonStudentIdRegex.test(columnName.trim())
          );

          // First Name
          const commonStudentFirstNameRegex =
            /^(?:(?:student[\s_-]*)?first(?:[\s_-]*name)?|student)$/i;
          const commonStudentFirstNameColumn = columnsNames.find((columnName) =>
            commonStudentFirstNameRegex.test(columnName.trim())
          );

          // Last Name
          const commonStudentLastNameRegex =
            /^(?:student[\s_-]*)?last(?:[\s_-]*name)?$/i;
          const commonStudentLastNameColumn = columnsNames.find((columnName) =>
            commonStudentLastNameRegex.test(columnName.trim())
          );

          // Teacher
          const commonTeacherRegex =
            /^(?:(?:official[\s_-]*)?teacher|rater)(?:[\s_-]*(?:name|K|(?:[1-9](?:st|nd|rd|th)|1[0-2]th)))?$/i;
          const commonTeacherColumn = columnsNames.find((columnName) =>
            commonTeacherRegex.test(columnName.trim())
          );

          // Grade
          const commonGradeRegex =
            /^(?:(?:student|enrollment)[\s_-]*)?grade(?:[\s_-]*at)?(?:[\s_-]*rating)?$/i;
          const commonGradeColumn = columnsNames.find((columnName) =>
            commonGradeRegex.test(columnName.trim())
          );

          // Race
          const commonRaceRegex =
            /^(?:student[\s_-]*)?race$/i;
          const commonRaceColumn = columnsNames.find((columnName) =>
            commonRaceRegex.test(columnName.trim())
          );

          // Gender
          const commonGenderRegex =
            /^(?:student[\s_-]*)?gender$/i;
          const commonGenderColumn = columnsNames.find((columnName) =>
            commonGenderRegex.test(columnName.trim())
          );

          // ELL
          const commonELLRegex =
            /^(?:(?:student[\s_-]*)?ell(?:[\s_-]*status)?(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?|englanglearn)$/i;
          const commonELLColumn = columnsNames.find((columnName) =>
            commonELLRegex.test(columnName.trim())
          );

          // SLD
          const commonSLDRegex =
            /^(?:(?:student[\s_-]*)?sld(?:[\s_-]*status)?|specific[\s_-]*(?:learning[\s_-]*)?disability(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?)$/i;
          const commonSLDColumn = columnsNames.find((columnName) =>
            commonSLDRegex.test(columnName.trim())
          );

          // Special Education
          const commonSpecialEducationRegex =
            /^(?:student[\s_-]*)?special(?:[\s_-]*(?:education|edsvc))$/i;
          const commonSpecialEducationColumn = columnsNames.find((columnName) =>
            commonSpecialEducationRegex.test(columnName.trim())
          );

          // Free or Reduced Lunch
          const commonFreeOrReducedLunchRegex =
            /^(?:(?:student[\s_-]*)?(?:meal[\s_-]*status|freereduced|free[\s_-]*(?:\/|or|&)?[\s_-]*reduced[\s_-]*lunch(?:\?[\s_-]*\(y[\s_-]*or[\s_-]*n\))?))$/i;
          const commonFreeOrReducedLunchColumn = columnsNames.find((columnName) =>
            commonFreeOrReducedLunchRegex.test(columnName.trim())
          );

          // Build column mappings with autoselection fallback
          const measurementMappings = selectedAssessment.measurements.reduce((obj: any, measurement) => {
            // Use the helper method to find matching column with dibels_columns support
            const matchedColumn = this.findMatchingColumn(
              measurement.column_name!,
              this.props.columnsNames
            );
            
            obj[measurement.column_name!] = matchedColumn;
            return obj;
          }, {});

          const autoSelectedColumnMappings = {
            [selectedAssessment.unique_id_column]: 
              this.props.columnsNames.find((columnName) => columnName === selectedAssessment.unique_id_column) 
              || commonStudentIdColumn,
            [selectedAssessment.first_name_column]: 
              this.props.columnsNames.find((columnName) => columnName === selectedAssessment.first_name_column)
              || commonStudentFirstNameColumn,
            [selectedAssessment.last_name_column]: 
              this.props.columnsNames.find((columnName) => columnName === selectedAssessment.last_name_column)
              || commonStudentLastNameColumn,
            ...measurementMappings,
          };

          return {
            ...prevState,
            column_name_mappings: autoSelectedColumnMappings,
            teacherColumn: commonTeacherColumn || "",
            gradeColumn: commonGradeColumn || "",
            raceColumn: commonRaceColumn || "",
            genderColumn: commonGenderColumn || "",
            ellColumn: commonELLColumn || "",
            sldColumn: commonSLDColumn || "",
            specialEducationColumn: commonSpecialEducationColumn || "",
            freeOrReducedLunchColumn: commonFreeOrReducedLunchColumn || "",
            selectedAssessment: selectedAssessment,
          };
        }
        return prevState;
      });
    }
  };

  handleOnSelect = (row: any, isSelect: boolean) => {
    if (isSelect) {
      this.setState({
        selectedAssessmentId: row.id,
      });
    }
  };

  handleAssessmentsFilterChange = (event: React.ChangeEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    this.setState({
      assessmentsFilter: value,
      evidenceAssessments: this.props.evidenceAssessments.filter(
        (evidenceAssessment) =>
          evidenceAssessment.name
            .toLowerCase()
            .includes(value.trim().toLowerCase())
      ),
    });
  };

  isRequiredFieldMissing = (fieldName?: string): boolean => {
    let isInvalid = false;
    const { selectedAssessment } = this.state;

    const validateField = (
      mappingKey: string,
      selectId: string,
      msgId: string
    ) => {
      const hasValue = !!this.state.column_name_mappings[mappingKey];

      const select = document.getElementById(selectId);
      const msg = document.getElementById(msgId);

      if (!hasValue) {
        if (select) {
          select.style.setProperty("border", "1px solid red");
        }

        if (msg) {
          msg.innerText = "This is a required field.";
          msg.style.setProperty("color", "red");
        }

        isInvalid = true;
      } else {
        if (select) {
          select.style.removeProperty("border");
        }

        if (msg) {
          msg.innerText = "";
          msg.style.removeProperty("color");
        }
      }
    };

    const fields = [
      {
        key: selectedAssessment?.unique_id_column as string,
        selectId: "uniqueIdColumnSelect",
        msgId: "uniqueIdColumnSelectMsg",
      },
      {
        key: selectedAssessment?.first_name_column as string,
        selectId: "firstNameColumnSelect",
        msgId: "firstNameColumnSelectMsg",
      },
      {
        key: selectedAssessment?.last_name_column as string,
        selectId: "lastNameColumnSelect",
        msgId: "lastNameColumnSelectMsg",
      },
      ...(selectedAssessment?.measurements || []).map((measurement) => ({
        key: measurement.column_name,
        selectId: `${measurement.column_name}Select`,
        msgId: `${measurement.column_name}SelectMsg`,
      })),
    ];

    fields.forEach((field) => {
      // validate only changed field during onChange
      if (!fieldName || field.key === fieldName) {
        validateField(field.key!, field.selectId, field.msgId);
      }
    });

    return isInvalid;
  };

  handleUploadStudentData = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { selectedAssessment } = this.state;
    this.setState({ isInvalid: this.isRequiredFieldMissing() }, () => {
      if (this.state.isInvalid == false) {
        let target_evidence_column_group_id;
        if (this.props.evidencePeriodData) {
          const ecg = this.props.evidencePeriodData.evidence_column_groups.find(
            (ecg) => ecg.assessment && ecg.assessment.id === selectedAssessment!.id
          );
          target_evidence_column_group_id = ecg ? ecg.id : undefined;
        }
        this.props.uploadUndefinedAssessmentData(
          this.state.selectedAssessment!.id,
          this.state.column_name_mappings,
          this.state.gradeColumn!,
          this.state.teacherColumn!,
          this.state.raceColumn!,
          this.state.genderColumn!,
          this.state.ellColumn!,
          this.state.sldColumn!,
          this.state.specialEducationColumn!,
          this.state.freeOrReducedLunchColumn!,
          this.props.currentDataPeriod?.time_period ?? this.state.timePeriod!,
          selectedAssessment!.unique_id_column,
          this.state.column_name_mappings[selectedAssessment!.unique_id_column],
          this.state.isDistrictAdmin,
          target_evidence_column_group_id,
          parseInt(this.props.currentDataPeriod?.year ?? this.state.year)
        ).then((response: any) => {
          if (response) {
            this.props.hideSearchForYourAssessmentModal();
            this.props.hideUploadStudentDataModal();
            this.setState({ selectedAssessment: undefined, selectedAssessmentId: undefined });
            if(this.props.currentRole == UserAssignmentRole.DISTRICT_OWNER) {
              toastr.info('File Received', response)
            } else {
              toastr.success('Success', response)
            }
          }
        });
      }
    });

  };

  handleModalShow = () => {
    this.setState({
      assessmentsFilter: "",
      selectedAssessment: undefined,
      selectedAssessmentId: undefined,
      sortField: undefined,
      sortOrder: undefined,
    }, () => this.props.getEvidenceAssessments());
  };

  handleModalHide = () => {
    if (
      !this.props.isLoading.getEvidenceAssessments &&
      !this.props.isLoading.uploadUndefinedAssessmentData
    ) {
      this.props.hideSearchForYourAssessmentModal();
    }
  };

  handleChange = (event: React.FormEvent<any>) => {
    const { name, value } = event.target as HTMLInputElement;
    this.setState(
      (prevState) => ({
        column_name_mappings: {
          ...prevState.column_name_mappings,
          [name]: value,
        },
      }),
      () => {
        this.isRequiredFieldMissing(name);
      }
    );
  };

  handleNonRequiredColumnChange = (event: React.FormEvent<any>) => {
    const { value, name } = event.target as HTMLInputElement;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  getOptions = (
    columnNameByOption?: string,
    showNoValueLabel: boolean = false
  ) => {
    const currentValue =
      columnNameByOption === "Teacher"
        ? this.state.teacherColumn
        : columnNameByOption === "Grade"
        ? this.state.gradeColumn
        : columnNameByOption === "Race"
        ? this.state.raceColumn
        : columnNameByOption === "Gender"
        ? this.state.genderColumn
        : columnNameByOption === "ELL"
        ? this.state.ellColumn
        : columnNameByOption === "SLD"
        ? this.state.sldColumn
        : columnNameByOption === "Special Education"
        ? this.state.specialEducationColumn
        : columnNameByOption === "Free or Reduced Lunch"
        ? this.state.freeOrReducedLunchColumn
        : this.state.column_name_mappings[columnNameByOption as any];

    const selectedValues = [
      ...Object.values(this.state.column_name_mappings),

      this.state.teacherColumn,
      this.state.gradeColumn,
      this.state.raceColumn,
      this.state.genderColumn,
      this.state.ellColumn,
      this.state.sldColumn,
      this.state.specialEducationColumn,
      this.state.freeOrReducedLunchColumn,
    ].filter(
      (value) => value && value !== currentValue
    );

    const options = this.props.columnsNames
      .filter((columnName) => !selectedValues.includes(columnName))
      .map((columnName) => (
        <option key={columnName} value={columnName}>
          {columnName}
        </option>
      ));

    const label =
      showNoValueLabel && !this.state.isInvalid
        ? `No Data for ${columnNameByOption}`
        : "";

    return (
      <>
        <option key={-1} value={label}>
          Select...
        </option>
        {options}
      </>
    );
  };


  getCreatedByLabel = (assessment: EvidenceAssessment): string => {
    if ((assessment as any).is_system_assessment) {
      return "ReadyCoach";
    }

    const owner = (assessment as any).owner || {};
    const firstName = owner.first_name || (assessment as any).created_by_first_name || "";
    const lastName = owner.last_name || (assessment as any).created_by_last_name || "";
    const nameFromParts = `${firstName} ${lastName}`.trim();

    if (nameFromParts) {
      return nameFromParts;
    }

    const fallbackName = owner.name || (assessment as any).created_by_name;
    return fallbackName || "-";
  };

  getSortedEvidenceAssessments = (assessments: Array<EvidenceAssessment>) => {
    const { sortField, sortOrder } = this.state;

    if (!sortField || !sortOrder) {
      return assessments;
    }

    const sorted = [...assessments];
    sorted.sort((a, b) => {
      let aValue: any;
      let bValue: any;

      switch (sortField) {
        case "name":
          aValue = a.name;
          bValue = b.name;
          break;
        case "is_system_assessment":
          aValue = a.is_system_assessment ? "System" : "Custom";
          bValue = b.is_system_assessment ? "System" : "Custom";
          break;
        case "use_grade_specific_color_criteria":
          aValue = a.use_grade_specific_color_criteria ? 1 : 0;
          bValue = b.use_grade_specific_color_criteria ? 1 : 0;
          break;
        case "with_reading_algorithm":
          aValue = a.with_reading_algorithm ? 1 : 0;
          bValue = b.with_reading_algorithm ? 1 : 0;
          break;
        case "dataColumns":
          aValue = a.measurements.map((m) => m.display_name).join(", ");
          bValue = b.measurements.map((m) => m.display_name).join(", ");
          break;
        case "createdBy":
          aValue = this.getCreatedByLabel(a);
          bValue = this.getCreatedByLabel(b);
          break;
        default:
          return 0;
      }

      const isEmpty = (val: any) => val === null || val === undefined || val === "";

      if (isEmpty(aValue) && !isEmpty(bValue)) return 1;
      if (!isEmpty(aValue) && isEmpty(bValue)) return -1;
      if (isEmpty(aValue) && isEmpty(bValue)) return 0;

      if (typeof aValue === "string" || typeof bValue === "string") {
        const aText = (aValue ?? "").toString().trim();
        const bText = (bValue ?? "").toString().trim();
        return sortOrder === "asc"
          ? collator.compare(aText, bText)
          : collator.compare(bText, aText);
      }

      return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
    });

    return sorted;
  };

  handleTableChange = (type: TableChangeType, { sortField: clickedField }: TableChangeState<any>) => {
    if (type === 'sort') {
      let newSortField: string | undefined = clickedField;
      let newSortOrder: 'asc' | 'desc' | undefined = 'asc';

      if (this.state.sortField === clickedField) {
        if (this.state.sortOrder === 'asc') {
          newSortOrder = 'desc';
        } else if (this.state.sortOrder === 'desc') {
          // Third click → Clear the sort
          newSortField = undefined;
          newSortOrder = undefined;
        }
      }

      this.setState({
        sortField: newSortField,
        sortOrder: newSortOrder,
      });
    }
  };

  handleDisplayAllRows = () => {
    this.setState({
      numPreviewRows: this.props.rawData.length,
    });
  };

  render() {
    const { selectedAssessment, evidenceAssessments } = this.state;
    const sortedEvidenceAssessments = this.getSortedEvidenceAssessments(evidenceAssessments);
    const isLoading =
      this.props.isLoading.getEvidenceAssessments ||
      this.props.isLoading.uploadUndefinedAssessmentData;
    const isEmpty =
      evidenceAssessments.length === 0 &&
      !this.props.isLoading.getEvidenceAssessments;

    const selectRow: SelectRowProps<any> = {
      mode: "radio",
      clickToSelect: false,
      selected: this.state.selectedAssessmentId
        ? [this.state.selectedAssessmentId]
        : [],
      onSelect: this.handleOnSelect,
      selectionHeaderRenderer: () => <span>Select</span>,
      headerColumnStyle: { textAlign: "center", pointerEvents: 'none' },
      selectionRenderer: ({ mode, ...rest }: any) => (
        <div style={{ textAlign: "center" }}>
          <input type={mode} {...rest} />
        </div>
      )
    };

    const classListDesc = (document.getElementsByClassName('caret-4-desc') as HTMLCollectionOf<HTMLElement>)?.[0];
    const classListAsc = (document.getElementsByClassName('caret-4-asc') as HTMLCollectionOf<HTMLElement>)?.[0];
    if (this.state.sortOrder === 'asc') {
      if (classListAsc) {
        classListAsc.style.display = 'inline-block';
      }
    } else if (this.state.sortOrder === 'desc') {
      if (classListDesc) {
        classListDesc.style.display = 'inline-block';
      }
    } else if (!this.state.sortField && !this.state.sortOrder) {
      if (classListAsc) {
        classListAsc.style.display = 'none';
      }
      if (classListDesc) {
        classListDesc.style.display = 'none';
      }
    }

    const basicColumnsHeadersSelected = 
      this.state.column_name_mappings[
        selectedAssessment?.unique_id_column as any
      ] && this.state.column_name_mappings[
        selectedAssessment?.first_name_column as any
      ] && this.state.column_name_mappings[
        selectedAssessment?.last_name_column as any
      ];

    const selectedMeasurements = selectedAssessment?.measurements.filter(
      (m) => m.column_name && m.column_name !== ""
    );

    return (
      //@ts-ignore
      <>
        {selectedAssessment
          ?
          <Modal
            animation={false}
            size="xl"
            backdropClassName="customDarkModalBackdrop inner in"
            show={selectedAssessment !== undefined}
            //@ts-ignore
            onHide={() => this.setState({ selectedAssessment: undefined, selectedAssessmentId: undefined })}
            centered
            className="teacher-invite-individually-modal"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className="purpleModalHeader">
              <Modal.Title>Map Columns for {selectedAssessment.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h4 className="font-weight-bold my-2">
                Select which columns from your file correspond to each assessment field.
              </h4>
              <Form
                id={"assessmentMappingForm"}
                onSubmit={this.handleUploadStudentData}
              >
                <Form.Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        {selectedAssessment.unique_id_column}
                        <span className="label-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        //required
                        name={selectedAssessment.unique_id_column}
                        as="select"
                        value={
                          this.state.column_name_mappings[
                          selectedAssessment.unique_id_column as any
                          ] || ""
                        }
                        onChange={(e) => this.handleChange(e)}
                        id={"uniqueIdColumnSelect"}
                      >
                        {this.getOptions(
                          selectedAssessment.unique_id_column
                        )}
                      </Form.Control>
                      <Form.Text id={"uniqueIdColumnSelectMsg"}>
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        {selectedAssessment.first_name_column}
                        <span className="label-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        //required
                        name={selectedAssessment.first_name_column}
                        as="select"
                        value={
                          this.state.column_name_mappings[
                          selectedAssessment.first_name_column as any
                          ] || ""
                        }
                        onChange={(e) => this.handleChange(e)}
                        id={"firstNameColumnSelect"}
                      >
                        {this.getOptions(selectedAssessment.first_name_column)}
                      </Form.Control>
                      <Form.Text id={"firstNameColumnSelectMsg"}>
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        {selectedAssessment.last_name_column}
                        <span className="label-asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        //required
                        name={selectedAssessment.last_name_column}
                        as="select"
                        value={
                          this.state.column_name_mappings[
                          selectedAssessment.last_name_column as any
                          ] || ""
                        }
                        onChange={(e) => this.handleChange(e)}
                        id={"lastNameColumnSelect"}
                      >
                        {this.getOptions(
                          selectedAssessment.last_name_column
                        )}
                      </Form.Control>
                      <Form.Text id={"lastNameColumnSelectMsg"}>
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Teacher Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"teacherColumn"}
                        as="select"
                        value={this.state.teacherColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >

                        {this.getOptions("Teacher")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Grade Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"gradeColumn"}
                        as="select"
                        value={this.state.gradeColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >
                        {this.getOptions("Grade")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Race Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"raceColumn"}
                        as="select"
                        value={this.state.raceColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >
                        {this.getOptions("Race")}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Gender Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"genderColumn"}
                        as="select"
                        value={this.state.genderColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >

                        {this.getOptions("Gender")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        ELL Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"ellColumn"}
                        as="select"
                        value={this.state.ellColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >
                        {this.getOptions("ELL")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        SLD Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"sldColumn"}
                        as="select"
                        value={this.state.sldColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >
                        {this.getOptions("SLD")}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Special Education Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"specialEducationColumn"}
                        as="select"
                        value={this.state.specialEducationColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >

                        {this.getOptions("Special Education")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  <Col>
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-left">
                        Free or Reduced Lunch Column
                      </Form.Label>
                      <Form.Control
                        //required
                        name={"freeOrReducedLunchColumn"}
                        as="select"
                        value={this.state.freeOrReducedLunchColumn}
                        onChange={this.handleNonRequiredColumnChange}
                      >
                        {this.getOptions("Free or Reduced Lunch")}
                      </Form.Control>
                    </Form.Group>
                  </Col>{" "}
                  
                </Form.Row>
                {selectedAssessment.measurements.map((measurement) => (
                  <Form.Group key={measurement.id}>
                    <Form.Label className="font-weight-bold text-left">
                      {measurement.column_name}
                      <span className="label-asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      name={measurement.column_name}
                      as="select"
                      value={
                        this.state.column_name_mappings[
                        measurement.column_name as any
                        ] || ""
                      }
                      onChange={(e) => this.handleChange(e)}
                      id={`${measurement.column_name}Select`}
                    >
                      {this.getOptions(measurement.column_name)}
                    </Form.Control>
                    <Form.Text id={`${measurement.column_name}SelectMsg`}>
                    </Form.Text>
                  </Form.Group>
                ))}
              </Form>
               {basicColumnsHeadersSelected && (
                    <>
                      <h6 className="font-weight-bold"> Data preview</h6>
                      <div className="table-responsive react-bootstrap-table">
                        <Table className="goalTable sticky-table-header" style={{minWidth: "max-content"}}>
                          <thead>
                            <tr>
                              <th>Student ID</th>
                              <th className="col-divider">Student First Name</th>
                              <th className="col-divider">Student Last Name</th>
                              {this.state.teacherColumn && this.state.teacherColumn !== "" && <th className="col-divider">Teacher</th>}
                              {this.state.gradeColumn && this.state.gradeColumn !== "" && <th className="col-divider">Grade</th>}
                              {this.state.raceColumn && this.state.raceColumn !== "" && <th className="col-divider">Race</th>}
                              {this.state.genderColumn && this.state.genderColumn !== "" && <th className="col-divider">Gender</th>}
                              {this.state.ellColumn && this.state.ellColumn !== "" && <th className="col-divider">ELL</th>}
                              {this.state.sldColumn && this.state.sldColumn !== "" && <th className="col-divider">SLD</th>}
                              {this.state.specialEducationColumn && this.state.specialEducationColumn !== "" && <th className="col-divider">Special Education</th>}
                              {this.state.freeOrReducedLunchColumn && this.state.freeOrReducedLunchColumn !== "" && <th className="col-divider">Free/Reduced Lunch</th>}
                              {selectedMeasurements?.filter((measurement) => 
                                this.state.column_name_mappings[measurement.column_name!]
                              ).map((measurement, index) => (
                                    <th
                                      key={index}
                                      className="col-divider"
                                    >
                                      {measurement.display_name}
                                    </th>
                                  )
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.rawData
                              .slice(0, this.state.numPreviewRows)
                              .map((element: any, index: number) => (
                                <tr key={element[this.state.column_name_mappings[selectedAssessment?.unique_id_column]] + index}>
                                  <td className="col-divider">{element[this.state.column_name_mappings[selectedAssessment?.unique_id_column]]}</td>
                                  <td className="col-divider">{element[this.state.column_name_mappings[selectedAssessment?.first_name_column]]}</td>
                                  <td className="col-divider">{element[this.state.column_name_mappings[selectedAssessment?.last_name_column]]}</td>
                                  {this.state.teacherColumn && this.state.teacherColumn !== "" && <td className="col-divider">{element[this.state.teacherColumn]}</td>}
                                  {this.state.gradeColumn && this.state.gradeColumn !== "" && <td className="col-divider">{element[this.state.gradeColumn]}</td>}
                                  {this.state.raceColumn && this.state.raceColumn !== "" && <td className="col-divider">{element[this.state.raceColumn]}</td>}
                                  {this.state.genderColumn && this.state.genderColumn !== "" && <td className="col-divider">{element[this.state.genderColumn]}</td>}
                                  {this.state.ellColumn && this.state.ellColumn !== "" && <td className="col-divider">{element[this.state.ellColumn]}</td>}
                                  {this.state.sldColumn && this.state.sldColumn !== "" && <td className="col-divider">{element[this.state.sldColumn]}</td>}
                                  {this.state.specialEducationColumn && this.state.specialEducationColumn !== "" && <td className="col-divider">{element[this.state.specialEducationColumn]}</td>}
                                  {this.state.freeOrReducedLunchColumn && this.state.freeOrReducedLunchColumn !== "" && <td className="col-divider">{element[this.state.freeOrReducedLunchColumn]}</td>}
                                  {selectedMeasurements?.filter((measurement) => 
                                    this.state.column_name_mappings[measurement.column_name!]
                                  ).map((measurement: Measurement, index: number) => (
                                        <PreviewDataCell
                                          key={measurement.id}
                                          index={index}
                                          element={element}
                                          measurement={measurement}
                                          mappedColumn={this.state.column_name_mappings[measurement.column_name!]}
                                        />
                                      )
                                    )}
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>
                      {this.props.rawData.length > this.state.numPreviewRows && (
                        <h6
                          className="font-weight-bold blueLink"
                          onClick={this.handleDisplayAllRows}
                          style={{ display: "inline" }}
                        >
                          And {this.props.rawData.length - this.state.numPreviewRows}{" "}
                          more...
                        </h6>
                      )}
                    </>
                  )}
              <hr/>
              <div className="btnActions">
                <div>
                  <button type="button" className="whiteBtnSm" onClick={() => this.setState({ selectedAssessment: undefined, selectedAssessmentId: undefined })}>
                    Back
                  </button>
                </div>
                <div>
                  <button
                    disabled={isLoading || !selectedAssessment}
                    type="submit"
                    form="assessmentMappingForm"
                    className="blueBtnSm"
                  >
                    SAVE & IMPORT{" "}
                    {this.props.isLoading.uploadUndefinedAssessmentData && (
                      <Spinner animation="border" size="sm" />
                    )}
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          : null
        }
        <Modal
          animation={false}
          size="xl"
          backdropClassName="customDarkModalBackdrop inner in"
          show={this.props.showModal}
          //@ts-ignore
          onShow={this.handleModalShow}
          onHide={this.handleModalHide}
          centered
          className="teacher-invite-individually-modal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton className="purpleModalHeader">
            <Modal.Title>Select Your Assessment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h3 className="font-weight-bold mb-3">Search and select the assessment you want to map your file to.</h3>
            <div className="spaceBetween mb-xl-3 mb-2">
              <InputGroup className="filterSearchDesktop mr-4" style={{ width: "300px" }}>
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  // value={this.state.assessmentsFilter}
                  onChange={this.handleAssessmentsFilterChange}
                  className="filterSearchHeight"
                />
              </InputGroup>
              {/* <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={
                    <Tooltip className="customTooltip" id= "tooltip-top">
                      Create new custom assessment
                    </Tooltip>
                  }
                >
                  <Button
                    bsPrefix="b"
                    className="blueBtnSm"
                    onClick={() => {
                      this.props.openUploadStudentDataModal(true);
                      this.props.hideSearchForYourAssessmentModal();
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faPlusCircle}
                      size="lg"
                      className="mr-1 pointer"
                      style={{color:"#fff"}}
                    />
                    CREATE ASSESSMENT
                  </Button>
                </OverlayTrigger> */}
            </div>
            {this.props.isLoading.getEvidenceAssessments ? (
              <LoadingIndicator type="table" rows={12} columns={8} />
            ) : (
              <>
                <BootstrapTable
                  remote={{ sort: true }}
                  wrapperClasses={
                    sortedEvidenceAssessments.length === 0 ? "rosterTableEmpty" : "fixedHeightTable sticky-table-header"
                  }
                  classes="goalTable"
                  keyField="id"
                  bordered={false}
                  bootstrap4
                  columns={columns}
                  data={sortedEvidenceAssessments.map((evidenceAssessment) => ({
                    id: evidenceAssessment.id,
                    name: evidenceAssessment.name,
                    is_system_assessment: evidenceAssessment.is_system_assessment,
                    use_grade_specific_color_criteria: evidenceAssessment.use_grade_specific_color_criteria,
                    with_reading_algorithm: evidenceAssessment.with_reading_algorithm,
                    dataColumns: evidenceAssessment.measurements
                      .map((measurement) => measurement.display_name)
                      .join(", "),
                    createdBy: this.getCreatedByLabel(evidenceAssessment),
                    actionsElement: (
                      !evidenceAssessment.is_system_assessment ? (
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          placement="top"
                          overlay={<Tooltip className="customTooltip" id="tooltip-top">View Assessment</Tooltip>}
                        >
                          <FontAwesomeIcon
                            icon={faEye}
                            className="pointer"
                            onClick={() => this.props.openAddAssessmentModal(false, evidenceAssessment, 'view', 'searchForYourAssessmentModal')}
                          />
                        </OverlayTrigger>
                      ) : null
                    ),
                  }))}
                  sort={this.state.sortField && this.state.sortOrder ? {
                    dataField: this.state.sortField,
                    order: this.state.sortOrder as SortOrder,
                  } : undefined}
                  onTableChange={this.handleTableChange}
                  noDataIndication={
                    isEmpty ? "No matching assessments" : <LoadingIndicator type="list" rows={20} columns={8} />
                  }
                  selectRow={selectRow}
                />
                <hr />

                <div className="btnActions">
                  <button type="button" className="whiteBtnSm" onClick={() => this.handleModalHide()}>
                    BACK
                  </button>
                  <button
                    className="blueBtnSm"
                    type="submit"
                    disabled={!this.state.selectedAssessmentId}
                    onClick={() => this.handleAssessmentSelect(this.state.selectedAssessmentId!, true)}
                  >
                    CONTINUE TO MAPPING
                  </button>
                </div>
              </>
            )
            }
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = ({ onboarding, auth }: ApplicationState): PropsFromState => {
  const { loadableFile } = onboarding;
  const rawData = loadableFile ? loadableFile.rawData : undefined;
  return {
    columnsNames: onboarding.loadableFile
      ? onboarding.loadableFile.columnsNames
      : [],
    currentDataPeriod: onboarding.currentDataPeriod,
    currentRole: auth.userInfo?.profile.current_role!,
    showModal: onboarding.modalsState.searchForYourAssessmentModal,
    evidenceAssessments: onboarding.evidenceAssessments,
    evidencePeriodData: onboarding.evidencePeriodData,
    rawData: rawData,
    studentIdColumn: loadableFile
      ? loadableFile.generatedStudentIdColumnName
      : undefined,
    isLoading: {
      uploadUndefinedAssessmentData:
        onboarding.isLoading.uploadUndefinedAssessmentData,
      getEvidenceAssessments: onboarding.isLoading.getEvidenceAssessments,
    },
    errors: {
      uploadUndefinedAssessmentData:
        onboarding.errors.uploadUndefinedAssessmentData,
      getEvidenceAssessments: onboarding.errors.getEvidenceAssessments,
    },
    enterDataManuallyType: onboarding.modalsState.enterDataManuallyType,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getEvidenceAssessments: getEvidenceAssessments,
      hideSearchForYourAssessmentModal: hideSearchForYourAssessmentModal,
      hideUploadStudentDataModal: hideUploadStudentDataModal,
      uploadUndefinedAssessmentData: uploadUndefinedAssessmentData,
      updateRawDataOfCsvFile: updateCsvFileRawData,
      getEvidenceInDataPeriod: getEvidenceInDataPeriod,
      //openUploadStudentDataModal: openUploadStudentDataModal,
      openFileUploadErrorModal: openFileUploadErrorModal,
      openAddAssessmentModal: openAddAssessmentModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchForYourAssessmentModal);
